/**
 * IVA toggle: unchecked (sin IVA) = thumb nearer "sin"; checked = precios con IVA.
 */
export const ivaPriceSwitchSx = {
  width: 52,
  height: 38,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: '8px',
    marginTop: '-2px',
    marginLeft: '-4px',
    '&.Mui-checked': {
      transform: 'translateX(26px)',
      color: '#fff !important',
    },
    '&:not(.Mui-checked)': {
      transform: 'translateX(-2px)',
    },
  },
  '& .MuiSwitch-thumb': {
    width: 20,
    height: 20,
    boxSizing: 'border-box',
    backgroundColor: '#fff',
  },
  '& .MuiSwitch-track': {
    height: '22px',
    borderRadius: 11,
    backgroundColor: '#e0e0e0',
    opacity: '1 !important',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#5FC56E !important',
    opacity: '1 !important',
  },
}
